export {Tooltip} from './tooltip/tooltip.component';
export type {TooltipProps} from './tooltip/tooltip.component';
